(function (w) {
	'use strict';

	MxMultiObjectPickerCtrl.$inject = [
		'$scope',
		'$q',
		'$element',
		'$timeout',
		'mx.SolutionBuilderAgent.EntityService',
		'mx.internationalization',
		'mx.SolutionBuilderAgent.DialogOpenerService',
		'mx.SolutionBuilderAgent.mxColumnDefinitionService',
		'mx.SolutionBuilderAgent.ExternalServiceManager',
		'mx.shell.KeyboardNavigationService',
		'mx.SolutionBuilderAgent.ContentWidgetService',
		'$attrs',
	];

	function MxMultiObjectPickerCtrl(
		$scope,
		$q,
		$element,
		$timeout,
		mxEntityService,
		i18n,
		dialogOpener,
		columnDefinition,
		externalServiceManager,
		keyboardNavigationService,
		contentWidgetService,
		$attrs
	) {
		var vm = this;

		vm.$onInit = function () {
			vm.isMultipleSelection = true;

			w.mx.SolutionBuilderAgent.ObjectPickerCtrl.call(
				vm,
				$scope,
				$q,
				$element,
				$timeout,
				mxEntityService,
				i18n,
				dialogOpener,
				columnDefinition,
				externalServiceManager,
				keyboardNavigationService,
				contentWidgetService,
				$attrs
			);

			//init the base class
			vm.$onInit.call(vm);
		};
	}

	/**
	 * @ngdoc directive
	 * @name mx.components:mxMultiObjectPicker
	 * @module mx.components
	 * @restrict 'E'
	 * @description
	 * The mx-multi-object-picker control is used to create a picker where user can select objects in multiple mode.
	 *
	 * The example below demonstrates some of the attributes you may use with the MultiObjectPicker control:
	 * @param {string} entityClassName@ - SPS class where data should be loaded from.
	 * @param {string} entityAttribute@ - Attribute of SPS class which should be returned.
	 * @param {string} filterExpression= - Expression to extract only specific records.
	 * @param {string} required= - The required property sets or returns whether a mxMultiObjectPicker must be filled out before submitting a form.
	 * @param {string} dropdownHtmlClass@ - This will be applied to the dropdown menu for styling.
	 * @param {string}  parentExpression - Refers Parent entity.  Used for hierarchical data, like Categories. Attribute
	 *
	 * @usage <mx-multi-object-picker data-label="Object Picker" ng-model="vm.selectedUsers" data-entity-class-name="SPSUserClassBase"> </mx-multi-object-picker>
	 */
	angular.module('mx.SolutionBuilderAgent').directive('mxMultiObjectPicker', function mxMultiObjectPickerDirective() {
		var directive = w.mx.SolutionBuilderAgent.ObjectPicker.getDirectiveDescriptor(
			MxMultiObjectPickerCtrl,
			'mx-multi-picker',
			' ng-model="vm.model" data-selected-items="vm.selectedItems" '
		);

		directive.bindToController.selectedItems = '=?';
		directive.bindToController.addOnBlur = '<?';

		angular.extend(directive.bindToController, w.mx.SolutionBuilderAgent.ObjectPicker.commonObjectPickerProperties);
		return directive;
	});
})(window);
